import { useObjectUrl } from '@hooks/useObjectUrl';
import type { ITaskAttachment } from '@interfaces/IScheduler';
import type { IPendingCommentPhoto } from '../../hooks/useCommentPhotoUploads';
import { EvidencePhoto } from './EvidencePhoto';
import styles from './TaskPanelCommentsTab.module.css';

/**
 * A posted comment's photo. Its `url` is the task's evidence route, fetched with
 * the session like a checklist photo. Comments posted before photos were
 * stored carry a tab-local `blob:` URL nobody else can open — those show their
 * file name instead of a broken image.
 */
export function CommentPhoto({ photo }: { photo: ITaskAttachment }) {
  if (photo.url.startsWith('blob:')) return <span className={styles.legacyName}>{photo.name}</span>;
  return <EvidencePhoto photo={photo} alt={photo.name} />;
}

/** A picked photo in the composer: previewed from the local file while it uploads. */
export function PendingCommentPhoto({ photo, onRemove }: { photo: IPendingCommentPhoto; onRemove: () => void }) {
  const src = useObjectUrl(photo.file);
  return (
    <div className={`${styles.pendingThumb} ${photo.stored ? '' : styles.uploading}`} aria-busy={!photo.stored}>
      {src && <img src={src} alt={photo.file.name} />}
      <button type="button" onClick={onRemove}>×</button>
    </div>
  );
}
